import { createSelector } from 'reselect'
import * as CardStatusRoles from 'const/CardStatusRoles'

const createIsCardOverdueSelector = () => {
  return createSelector<{ isArchived, isTemplate, dueDate, statusId, isBoardClosed, cardStatusesById }, any, boolean>(
    [
      ({ isArchived }) => isArchived,
      ({ isTemplate }) => isTemplate,
      ({ dueDate }) => dueDate,
      ({ statusId }) => statusId,
      ({ isBoardClosed }) => isBoardClosed,
      ({ cardStatusesById }) => cardStatusesById,
    ],
    (
      isArchived,
      isTemplate,
      dueDate,
      statusId,
      isBoardClosed,
      cardStatusesById,
    ) =>
      (!isArchived && !isTemplate && !isBoardClosed && dueDate && cardStatusesById[statusId])
        ? (
          (
            cardStatusesById[statusId].role !== CardStatusRoles.NONE &&
            cardStatusesById[statusId].role !== CardStatusRoles.COMPLETED
          )
            ? Date.now() > dueDate
            : false
        )
        : false
  )
}

export default createIsCardOverdueSelector